import { environment } from '@fb/environments';

import {
  AUTH_PATH,
  CONFIGS_PATH,
  HEALTH_CHECK_PATH,
  I18N_ASSETS_PATH,
} from './auth-http.constants';

function isApiRequest(url: string): boolean {
  try {
    const apiHost = environment.apiHost;

    if (!apiHost) {
      return false;
    }

    const apiOrigin = new URL(apiHost).origin;

    if (url.startsWith('http://') || url.startsWith('https://')) {
      return new URL(url).origin === apiOrigin;
    }
  } catch {
    return false;
  }

  return url.includes('/api/');
}

export function shouldSendCredentials(url: string): boolean {
  return !url.includes(I18N_ASSETS_PATH)
    && !url.includes(CONFIGS_PATH)
    && isApiRequest(url);
}

export function shouldSkipRenewal(url: string): boolean {
  return !isApiRequest(url)
    || url.includes(`/${AUTH_PATH}/`)
    || url.includes(I18N_ASSETS_PATH)
    || url.includes(CONFIGS_PATH)
    || url.includes(HEALTH_CHECK_PATH);
}

export function getRefreshUrl(): string {
  const apiHost = environment.apiHost || '';
  const normalized = apiHost.endsWith('/') ? apiHost : `${apiHost}/`;

  return `${normalized}auth/refresh/`;
}
